(ns dashboard.views.workbook-workspace.events
  (:require [clojure.set :as set]
            [re-frame.core :as rf]
            [dashboard.ui :as ui]
            [dashboard.services.http-config :as http-config]
            [dashboard.notifications :as notifications]))

(rf/reg-event-db
  ::workbook-workspace.panel.set-size
  (fn [db [_ panel size]]
    (cond-> db
      (pos? size)
      (update-in [:workbook-workspace panel] assoc :size size))))

(rf/reg-event-db
  ::workbook-workspace.panel.toggle-visibility
  (fn [db [_ panel]]
    (update-in db [:workbook-workspace panel :is-visible?] not)))

;; Set workbook browser path.
;; [<workbooks>, <workbook>, <sheet>]
;; If path set has sheet, set the grids active view.
(rf/reg-event-fx
  ::workbook-workspace.browser.set-path
  (fn [{:keys [db]} [_ path]]
    (merge {:db (assoc-in db [:workbook-workspace :browser :path] path)}
           (case (count path)
             2 {:dispatch [::workbook-workspace.grid.workbook.sheet-list.fetch (last path)]}
             3 {:dispatch [::workbook-workspace.grid.workbook.set-active (last path)]}
             nil))))

(rf/reg-event-fx
 ::workbook-workspace.browser.force-path-for-modal
 (fn [{:keys [db]} [_ path]]
   {:db (-> (assoc-in db [:workbook-workspace :browser :path] path)
            (assoc-in [:workbook-workspace :browser :workbooks] nil)
            (assoc-in [:workbook-workspace :grid] nil))
    :dispatch [::workbook-workspace.grid.workbook.sheet-list.fetch (last path)]}))

(rf/reg-event-fx
 ::workbook-workspace.grid.workbook.sheet-list.fetch
 (fn [{:keys [db]} [_ {:keys [questionnaire]}]]
   {:db (assoc-in db [:workbook-workspace :browser :workbooks questionnaire :loading-sheets?] true)
    :http-xhrio {:method :get
                 :uri (str "/api/questionnaires/" questionnaire "/sheet/")
                 :response-format http-config/transit-response-format
                 :on-success [::workbook-workspace.grid.workbook.sheet-list.fetch.on-success questionnaire]
                 :on-failure [::ui/set-error "Failed to get workbook sheets"]}}))

(rf/reg-event-db
  ::workbook-workspace.grid.workbook.sheet-list.fetch.on-success
  (fn [db [_ questionnaire sheets]]
    (update-in db [:workbook-workspace :browser :workbooks questionnaire]
               (fn [questionnaire]
                 (-> questionnaire
                     (assoc :loading-sheets? false)
                     (assoc :sheets sheets))))))

(comment
  #_{:clj-kondo/ignore [:clojure-lsp/unused-public-var]}
  (defn generate-mock-rows [rows cols]
    (let [char-A 65]
      (partition cols
                 (for [r (range rows)
                       c (range char-A (+ char-A cols))]
                   (let [col (- c char-A)]
                     {:content (if (= col 2)
                                 (when (< (rand) 0.8) (str "A." r))
                                 (str "content_(" r "," col ")"))
                      :row r
                      :col col
                      :ref  (str (char c) (inc r))}))))))

(rf/reg-event-fx
  ::load-workbook-sheet
  (fn [_ [_ questionnaire sheet-id]]
    {:http-xhrio {:method          :get
                  :uri             (str "/api/questionnaires/" questionnaire  "/sheet/" sheet-id)
                  :timeout         http-config/timeout
                  :response-format http-config/transit-response-format
                  :on-success      [::workbook-workspace.sheet.fetch.on-success questionnaire sheet-id]
                  :on-failure      [::workbook-workspace.sheet.fetch.on-failure]}}))

;; Fetch the parsing configuration for the active workbook sheet
(rf/reg-event-fx
  ::workbook-workspace.active-sheet.configuration.fetch
  (fn [_ [_ questionnaire sheet-id]]
    {:http-xhrio {:method          :get
                  :uri             (str "/api/questionnaires/" questionnaire "/sheet/" sheet-id "/configuration")
                  :timeout         http-config/timeout
                  :response-format http-config/transit-response-format
                  :on-success      [::workbook-workspace.active-sheet.configuration.fetch.on-success questionnaire sheet-id]
                  :on-failure      [::ui/set-error {:message "Could not fetch active sheet configuration"}]}}))

(rf/reg-event-db
  ::workbook-workspace.active-sheet.configuration.fetch.on-success
  (fn [db [_ questionnaire sheet-id result]]
    (assoc-in db
              [:workbook-workspace :workbooks questionnaire sheet-id :parsing-config]
              result)))

(rf/reg-event-db
  ::workbook-workspace.sheet.fetch.on-success
  (fn [db [_ questionnaire sheet-id rows]]
    (-> db
        (assoc-in [:workbook-workspace :grid :is-loading?] false)
        (assoc-in [:workbook-workspace :workbooks questionnaire sheet-id :rows] rows))))

(rf/reg-event-db
  ::workbook-workspace.sheet.fetch.on-failure
  (fn [db [_ error]]
    (-> db
        (assoc-in [:workbook-workspace :grid :is-loading?] false)
        (assoc-in [:ui :error] error))))

;; On set active the loading of the grid views
;; data should be initialized.
;;
;; This should clear the grid to not show the
;; data from previous sheet while loading the
;; new data.
(rf/reg-event-fx
  ::workbook-workspace.grid.workbook.set-active
  (fn [{db :db} [_ {:keys [questionnaire sheet-id sheet-name]}]]
    {:db (assoc-in db [:workbook-workspace :grid] {:questionnaire questionnaire
                                                   :sheet-id sheet-id
                                                   :sheet-name sheet-name
                                                   :selected-rows #{}
                                                   :is-loading? true})
     :fx [[:dispatch [::workbook-workspace.active-sheet.configuration.fetch questionnaire sheet-id]]
          [:dispatch [::load-workbook-sheet questionnaire sheet-id]]]}))

(rf/reg-event-db
  ::workbook-workspace.workbook.sheet.config.set-value
  (fn [db [_ {:keys [workbook sheet k v]}]]
    (assoc-in db [:workbook-workspace :workbooks workbook sheet :parsing-config :columns v] k)))

(rf/reg-event-db
  ::workbook-workspace.workbook.sheet.config.clear-value
  (fn [db [_ {:keys [workbook sheet k]}]]
    (update-in db [:workbook-workspace :workbooks workbook sheet :parsing-config :columns] dissoc k)))

;; TODO continue from here
;; If context menu click on a row that is not in selection
;; change selection focus to the clicked row
(rf/reg-event-db
  ::workbook-workspace.context-menu.open
  (fn [db [_  {row-index :row-index :as context}]]
    (let [selected-rows (get-in db [:workbook-workspace :grid :selected-rows])]
      (-> db
          (update-in [:workbook-workspace :grid] merge (when-not (contains? selected-rows row-index)
                                                         {:latest-focus row-index
                                                          :selected-rows #{row-index}}))
          (update-in [:workbook-workspace :context-menu] merge
                     (merge  {:is-visible? true}
                             context))))))

(rf/reg-event-db
  ::workbook-workspace.context-menu.close
  (fn [db _]
    (assoc-in db
              [:workbook-workspace :context-menu]
              {:is-visible? false})))


;; # add set of row indices as sheets question rows
;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;

(rf/reg-event-db
  ::workbook-workspace.active-sheet.add-question-rows
  (fn [db [_ rows]]
    (let [{:keys [questionnaire sheet-id]} (get-in db [:workbook-workspace :grid])]
      (if (and questionnaire sheet-id)
        (update-in db [:workbook-workspace :workbooks questionnaire sheet-id :parsing-config :question-rows] (comp set concat) rows)
        db))))

;; # remove row from the question rows
;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;

(rf/reg-event-db
  ::workbook-workspace.active-sheet.remove-question-row
  (fn [db [_ row]]
    (let [{:keys [questionnaire sheet-id]} (get-in db [:workbook-workspace :grid])
          remove-row               (partial (comp set remove) #(= row %))
          parsing-config-path [:workbook-workspace :workbooks questionnaire sheet-id :parsing-config]
          value-exceptions-path (conj parsing-config-path :value-exceptions)
          question-rows-path (conj parsing-config-path :question-rows)]
      (if (and questionnaire sheet-id)
        (cond-> (update-in db question-rows-path remove-row)
          ;; remove exceptions only if exists to avoid nil values
          (get-in db value-exceptions-path)
          (update-in value-exceptions-path dissoc row))
        db))))

(rf/reg-event-fx
  ::workbook-workspace.active-sheet.remove-question-rows
  (fn [{db :db} [_ rows]]
    {:db db
     :fx (mapv
           (fn [row]
             [:dispatch [::workbook-workspace.active-sheet.remove-question-row row]])
           rows)}))

;; # Set a set of rows as hidden rows
;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;

(rf/reg-event-db
  ::workbook-workspace.active-sheet.hide-rows
  (fn [db [_ rows]]
    (let [{:keys [questionnaire sheet-id]} (get-in db [:workbook-workspace :grid])]
      (if (and questionnaire sheet-id)
        (update-in db [:workbook-workspace :workbooks questionnaire sheet-id :hidden-rows] (comp set concat) rows)
        db))))


;; # Set a set of rows as hidden rows
;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;

(rf/reg-event-db
  ::workbook-workspace.active-sheet.unhide-rows
  (fn [db [_ rows]]
    (let [{:keys [questionnaire sheet-id]} (get-in db [:workbook-workspace :grid])]
      (if (and questionnaire sheet-id)
        (update-in db [:workbook-workspace :workbooks questionnaire sheet-id :hidden-rows] set/difference rows)
        db))))

(rf/reg-event-db
  ::workbook-workspace.active-sheet.toggle-hidden-row-visibility
  (fn [db _]
    (let [{:keys [questionnaire sheet-id]} (get-in db [:workbook-workspace :grid])]
      (if (and questionnaire sheet-id)
        (update-in db [:workbook-workspace :workbooks questionnaire sheet-id :show-hidden-rows?] not)
        db))))

(rf/reg-event-db
  ::workbook-workspace.active-sheet.depth.set-source
  (fn [db [_ val]]
    (let [{:keys [questionnaire sheet-id]} (get-in db [:workbook-workspace :grid])]
      (if (and questionnaire sheet-id)
        (assoc-in db [:workbook-workspace :workbooks questionnaire sheet-id :parsing-config :depth-source] val)
        db))))

(rf/reg-event-db
  ::workbook-workspace.grid.set-selected-cells
  (fn [db [_ cells]]
    (update-in db [:workbook-workspace :grid] merge {:selected-rows nil
                                                     :selected-cells cells})))

(rf/reg-event-db
  ::workbook-workspace.grid.clear-selection
  (fn [db _]
    (assoc-in db [:workbook-workspace :grid :selected-rows] #{})))

(rf/reg-event-fx
  ::workbook-workspace.grid.on-cell-click
  (fn [_ [_ {:keys [shift-key meta-key row-index]}]]
    {:dispatch [::workbook-workspace.grid.on-row-click
                {:shift-key shift-key
                 :meta-key meta-key
                 :row-index row-index}]}))

(rf/reg-event-db
  ::workbook-workspace.grid.on-row-click
  (fn [db [_ {:keys [shift-key meta-key row-index]}]]
    (let [{:keys [selected-rows latest-focus]} (get-in db [:workbook-workspace :grid])
          new-selected-rows (cond
                              shift-key (into selected-rows (apply range (sort [latest-focus (if (> row-index latest-focus)
                                                                                               (inc row-index)
                                                                                               row-index)])))

                              meta-key (if (contains? selected-rows row-index)
                                         (disj selected-rows row-index)
                                         (conj selected-rows row-index))

                              :else (if
                                        ;; If clicked selected row that was the only one
                                        ;; selected clear the selection, otherwise set
                                        ;; row-index as selected
                                        (= selected-rows #{row-index})
                                      #{}
                                      #{row-index}))]
      (update-in db [:workbook-workspace :grid] merge {:latest-focus row-index
                                                       :selected-cells nil
                                                       :selected-rows new-selected-rows}))))

(rf/reg-event-db
  ::workbook-workspace.active-sheet.value-exception.set
  (fn [db [_ {:keys [name value row-index]}]]
    (let [{:keys [questionnaire sheet-id]} (get-in db [:workbook-workspace :grid])]
      (if (and questionnaire sheet-id)
        (-> db
            (assoc-in  [:workbook-workspace
                        :workbooks
                        questionnaire
                        sheet-id
                        :parsing-config
                        :value-exceptions
                        row-index
                        name] {:value value}))
        db))))

(rf/reg-event-db
  ::workbook-workspace.active-sheet.value-exception.clear
  (fn [db [_ {:keys [name row-index]}]]
    (let [{:keys [questionnaire sheet-id]} (get-in db [:workbook-workspace :grid])]
      (if (and questionnaire sheet-id)
        (-> db
            (update-in [:workbook-workspace
                        :workbooks
                        questionnaire
                        sheet-id
                        :parsing-config
                        :value-exceptions
                        row-index] dissoc name))
        db))))

;; # Workbook Workspace - Browser - Fetch Workbooks On Success
;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;

(rf/reg-event-db
  ::workbook-workspace.browser.fetch-workbooks.on-success
  (fn [db [_ questionnaires]]
    (update-in db
               [:workbook-workspace :browser]
               merge
               {:loading-workbooks? false
                :workbooks          (into {}
                                          (map (fn [questionnaire]
                                                 [(:id questionnaire) questionnaire]))
                                          questionnaires)})))

;; # Workbook Workspace - Browser - Fetch Workbooks
;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;; TODO: We should remove whole workbook, aka excel files.
;;       The domain entity "questionnaire" might originate from sources like
;;         * Excel file
;;         * Web portal
;;         * Authored inside Repliance (when we have this functionality)
;;       By navigating into the "workbook", aka "excel parsing assistant, from the list of questionnaires,
;;       we get to skip the listing of excel files totally.
(rf/reg-event-fx
  ::workbook-workspace.browser.fetch-workbooks
  (fn [{:keys [db]} _]
    (let [features-enabled (-> db :user :features_enabled)]
      {:db       (assoc-in db [:workbook-workspace :browser :loading-workbooks?] true)
       :http-xhrio {:method          :get
                    :uri             "/api/questionnaires/"
                    :url-params      {:type "workbook"
                                      :template (contains? features-enabled :structured-analysis-creation)}
                    :timeout         http-config/timeout
                    :response-format http-config/transit-response-format
                    :on-success      [::workbook-workspace.browser.fetch-workbooks.on-success]
                    :on-failure      [::ui/set-error {:message "Could not fetch workbooks (aka questionnaires that are excel files)"}]}})))

;; Save active sheets configuration to Dynamo DB.
;;
;; TODO fix: if trying to save an empty configuration will raise an error
;; - maybe `delete-item` if trying to save an empty config
;; - requires creating `delete-item` API GW integration
(rf/reg-event-fx
  ::workbook-workspace.active-sheet.configuration.save
  (fn [{:keys [db]} _]
    (let [{:keys [questionnaire sheet-id]} (-> db :workbook-workspace :grid)
          active-sheet                       (get-in db [:workbook-workspace :workbooks questionnaire sheet-id])]
      (when active-sheet
        {:http-xhrio {:method          :post
                      :uri             (str "/api/questionnaires/" questionnaire "/sheet/" sheet-id)
                      :timeout         http-config/timeout
                      :format          http-config/transit-request-format
                      :response-format http-config/transit-response-format
                      :params          (:parsing-config active-sheet)
                      :on-success      [::notifications/add {:message "Configuration saved successfully."}]
                      :on-failure      [::ui/set-error {:message "Could not update sheet parsing configuration"}]}}))))

